<template>
    <div class="setting">
        <el-form :model="searchData" size="small" class="el-form__inline">
            <el-row :gutter="10">
                <el-col :span="4">
                    <el-form-item>
                        <el-input
                            v-model="searchData.name"
                            placeholder="部门名称"
                            clearable
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item>
                        <el-button type="primary" plain icon="el-icon-search" @click="SearchProduct"
                            >搜索</el-button
                        >
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="card">
            <div class="list" v-loading="departmentData.loading.list">
                <div class="list-control t-right">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-circle-plus"
                        @click="DetailDepartment"
                        >部门</el-button
                    >
                </div>
                <div class="list-table">
                    <el-table :data="departmentData.list" stripe style="width: 100%">
                        <el-table-column prop="name" label="部门" width="240"></el-table-column>
                        <el-table-column prop="describe" label="描述"></el-table-column>
                        <el-table-column width="120" fixed="right">
                            <template slot-scope="scope">
                                <div class="t-right">
                                    <el-link
                                        type="primary"
                                        :underline="false"
                                        @click="DetailDepartment(scope.row)"
                                        >修改</el-link
                                    >
                                    <el-divider direction="vertical"></el-divider>
                                    <el-link
                                        type="primary"
                                        :underline="false"
                                        @click="DelDepartment(scope.row)"
                                        >删除</el-link
                                    >
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="list-pagination">
                    <el-pagination
                        background
                        layout="total, prev, pager, next, sizes"
                        :current-page.sync="departmentData.pages.page"
                        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                        :page-size="departmentData.pages.pagesize"
                        :total="departmentData.pages.total"
                        @size-change="GetSize"
                        @current-change="GetCurrent"
                    ></el-pagination>
                </div>
            </div>
        </div>

        <v-DepartmentForm
            :detailParam="componentParam.departmentForm"
            v-if="componentParam.departmentForm.visible"
        />
    </div>
</template>

<script>
import DepartmentForm from '@/components/department/Form'
import { UserData } from '@/plugin/User'
export default {
    components: {
        'v-DepartmentForm': DepartmentForm
    },
    inject: ['reload'],
    mixins: [UserData],
    data() {
        return {
            searchData: {},
            departmentData: {
                loading: {
                    list: false
                },
                list: [],
                pages: {
                    page: 1,
                    pagesize: 10,
                    total: 0
                }
            },
            componentParam: {
                departmentForm: {}
            }
        }
    },
    created() {
        this.$nextTick(() => {})
    },
    mounted() {
        this.$nextTick(() => {
            this.GetDepartment()
        })
    },
    methods: {
        SearchProduct() {
            this.departmentData.pages.page = 0
            this.GetDepartment()
        },
        // 部门列表
        GetDepartment() {
            this.departmentData.loading.list = true
            this.GetDepartmentData({
                data: {
                    ...this.searchData,
                    ...this.departmentData.pages
                }
            }).then(res => {
                this.departmentData.loading.list = false
                this.departmentData.list = res.list
                this.departmentData.pages.total = parseInt(res.total)
            })
        },
        GetSize(val) {
            this.departmentData.pages.pagesize = val
            this.GetDepartment()
        },
        GetCurrent(val) {
            this.departmentData.pages.page = val
            this.GetDepartment()
        },
        DetailDepartment(row) {
            this.componentParam.departmentForm = {
                visible: true,
                row: row.id
                    ? {
                          id: row.id,
                          name: row.name,
                          describe: row.describe
                      }
                    : {}
            }
        },
        DelDepartment(row) {
            this.$confirm('此操作将永久删除当前数据, 是否继续?', '警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$request({
                        url: '/api/v1/department_del',
                        params: {
                            id: row.id
                        }
                    }).then(res => {
                        this.$message({
                            message: res.message || (res.status ? '操作失败' : '操作成功'),
                            type: res.status ? 'error' : 'success'
                        })
                        if (!res.status) {
                            this.reload()
                        }
                    })
                })
                .catch(() => {})
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/common.less';
@import '~@/assets/css/list.less';
</style>
